import {Component, Injector} from '@angular/core';
import {ProductParameterFormatState, Store} from './state/store';
import {ProductParameterFormat} from './state/model';
import {EntityListComponent} from '../../components/entity-list/component';
import {FilterService} from './filter.service';
import {ProductParameterFormatQuery} from './state/query';
import {ProductParameterFormatService} from './state/service';

@Component({
  templateUrl: '../../components/entity-list/component.html',
  styleUrls: ['../../components/entity-list/component.scss']
})
export class ProductParameterFormatListComponent extends EntityListComponent<ProductParameterFormat, ProductParameterFormatState, Store> {

  translationDomain = 'productParameterFormat';

  constructor(
    public injector: Injector,
    protected service: ProductParameterFormatService,
    query: ProductParameterFormatQuery,
    private ProductParameterFormatFilterService: FilterService) {
    super(injector, service, query, ProductParameterFormatFilterService);
  }
  canEdit(): boolean {
    return this.hasRole('ROLE_ADMIN');
  }
}
